import { render, staticRenderFns } from "./popover-input.vue?vue&type=template&id=5638dedd&scoped=true"
import script from "./popover-input.vue?vue&type=script&lang=ts"
export * from "./popover-input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638dedd",
  null
  
)

export default component.exports